import EleUploadFile from './EleUploadFile'

export default EleUploadFile
